module.exports = __webpack_public_path__ + "img/coverall.3398f6eb.png";